import { api, apiUrl } from "../../api/index";

const url = `${apiUrl}/tutorials`;

export const fetchTutorials = () => {
  return api(url, {
    method: "GET",
  });
};

export const createTutorial = ({
  payload,
}: {
  payload: { title: string; url: string };
}) => {
  return api(`${url}/create`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const updateTutorial = ({
  id,
  payload,
}: {
  id: number;
  payload: object;
}) => {
  return api(`${url}/update/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
};

export const deleteTutorial = ({ id }: { id: number }) => {
  return api(`${url}/destroy/${id}`, {
    method: "DELETE",
  });
};
